<template>
    <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.65 18.7794V15.3594H1V5.41052H9.63V2C11.87 4.81698 14.12 7.63395 16.32 10.3944C14.17 13.0983 11.92 15.9247 9.65 18.7794Z"
            fill="#284070" stroke="#284070" />
    </svg>
</template>